// src/components/Section.jsx
import PropTypes from 'prop-types';

function Section({
  children,
  background = 'bg-white', // Default background color
  width = 'fixed', // 'fixed' or 'fluid'
  backgroundSize = 'cover', // 'cover', 'contain', or custom value
  className = '',
  ...props
}) {
  const baseStyles = 'py-12 px-4 sm:px-6 lg:px-8';
  const widthStyles = width === 'fluid' ? 'w-full' : 'max-w-7xl mx-auto';
  const bgStyles = background.startsWith('url')
    ? `bg-${backgroundSize} bg-top bg-no-repeat ${background.split(' ')[1] || 'bg-gray-100'}`
    : background;

  return (
    <section
      className={`${baseStyles} ${widthStyles} ${bgStyles} ${className}`}
      style={background.startsWith('url') ? { backgroundImage: background } : {}}
      {...props}
    >
      {children}
    </section>
  );
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  width: PropTypes.oneOf(['fixed', 'fluid']),
  backgroundSize: PropTypes.string,
  className: PropTypes.string,
};

export default Section;